import { Routes } from '@angular/router';

export const reportAnalysisRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./report-analysis.component').then((m) => m.ReportAnalysisComponent),
  },
  {
    path: 'active-loans',
    loadComponent: () => import('./components/active-loans/active-loans.component').then((m) => m.ActiveLoansComponent),
  },
  {
    path: 'overdue-repayment',
    loadComponent: () => import('./components/overdue-loans/overdue-loans.component').then((m) => m.OverdueLoansComponent),
  },
  {
    path: 'collected-month',
    loadComponent: () => import('./components/collected-month/collected-month.component').then((m) => m.CollectedMonthComponent),
  },
  {
    path: 'due-month',
    loadComponent: () => import('./components/due-month/due-month.component').then((m) => m.DueMonthComponent),
  },
];
